import styled from "styled-components";
import Contracts from "./Contracts";
import Details from "./Details";
import PlayerPicture from "./PlayerPicture";
import { useState } from "react";
import {User} from "../../../models/user";
import { FC } from "react";

interface Props {
  player: User,
}

const Overview: FC<Props> = ({ player }) => {
  const [editProfile, setEditProfile] = useState(false);

  return (
    <>
      <div style={{ position: "relative" }} className="mt-4 mt-md-5 mb-4">
        {/* h-80 removed - was causing gaps on mobile */}
        <div className="container d-flex flex-column flex-lg-row justify-content-start align-items-center">
        <DisplayLargeScreens className=" order-lg-3 col-12 col-md-12 col-lg-4">
          {/* overview pic */}
          <PlayerPicture
            player={player}
          />
        </DisplayLargeScreens>
        <DisplaySmallScreens className=" order-lg-3 col-12 col-md-12 col-lg-4 h-100">
          <Contracts player={player} />
        </DisplaySmallScreens>
        <Middle className="col-lg-8">
          <DisplayLargeScreens className="order-lg-2 col-12 col-md-6 col-lg-6 h-100">
            {/* contracts / leagues */}
            <Contracts player={player} />
          </DisplayLargeScreens>
          <DisplaySmallScreens className="order-lg-2 col-12 col-md-6 col-lg-6">
            {/* overview pic */}
            <PlayerPicture
              player={player}
            />
          </DisplaySmallScreens>
          <div className="order-lg-1 col-12 col-md-6 col-lg-6">
            <Details
              player={player}
              editProfile={editProfile}
              setEditProfile={setEditProfile}
            />
          </div>
        </Middle>
        {/* </Wrapper> */}
      </div>
      </div>
    </>
  );
};

export default Overview;

const Wrapper = styled.div`
  border: solid 2px red;
`;

const Middle = styled.div`
  display: block;
  @media (min-width: 768px) {
    // large screens
    display: flex;
  }
`;
const DisplayLargeScreens = styled.div`
  @media (min-width: 992px) {
    // large screens
    display: none;
  }
`;
const DisplaySmallScreens = styled.div`
  @media (max-width: 992px) {
    // large screens
    display: none;
  }
`;
